import { ListItem, Stack } from "@mui/material";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Log } from "@ryde/shared";

import {
  ColorIconButton,
  EmailInputByControl,
  PhoneInputByControl,
  TextInputByControl,
} from "../../../controls";
import { ContactItemEditRootStyled } from "./contact-item.styled";
import { IContactItem, IContactItemForm } from "./table-contacts.models";

export const ContactItemEdit: FC<IContactItemForm> = ({
  index,
  value,
  onCancel,
  setValue,
  fieldName,
}) => {
  const { t } = useTranslation();
  const { handleSubmit, control } = useForm<Partial<IContactItem>>({
    defaultValues: value,
  });

  const updateValuesHandler = handleSubmit(data => {
    const targetField = `${fieldName || ""}.${index || 0}`;
    Log.debug(`Set value for contact item target field:  ${targetField}`, data);
    setValue?.(targetField, data, {
      shouldValidate: true,
      shouldDirty: true,
    });
    onCancel?.();
  });

  return (
    <ContactItemEditRootStyled>
      <ListItem
        alignItems="flex-start"
        data-e2e="contact-item-edit"
        secondaryAction={
          <>
            <ColorIconButton
              iconType="CHECK"
              edge="end"
              aria-label="save"
              onClick={updateValuesHandler}
            />

            <ColorIconButton
              iconType="CANCEL"
              edge="end"
              aria-label="cancel"
              onClick={() => onCancel?.()}
            />
          </>
        }
      >
        <Stack spacing={1} sx={{ width: "91%" }}>
          <TextInputByControl
            name={`name`}
            control={control}
            formLabel={t("supplier.formLabel.contactName")}
            formValidation={{
              type: "string",
              rules: [
                {
                  validation: "required",
                },
              ],
            }}
          />

          <TextInputByControl
            name={`jobTitle`}
            control={control}
            formLabel={t("supplier.formLabel.contactJobTitle")}
          />

          <PhoneInputByControl
            name={`phone`}
            control={control}
            formLabel={t("supplier.formLabel.contactPhone")}
          />

          <EmailInputByControl
            name={`email`}
            control={control}
            formLabel={t("supplier.formLabel.contactEmail")}
          />
        </Stack>
      </ListItem>
    </ContactItemEditRootStyled>
  );
};
